import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../services/AuthProvider";
import Spinner from "./spinner";

const AdminRoute = () => {
  const { currentUser, isLoading } = useAuth();

  // Loading state
  if (isLoading) {
    return (
      <main className="p-4 md:p-10 mx-auto max-w-7xl">
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
          <Spinner />
        </div>
      </main>
    );
  }

  // Check if user is admin
  if (currentUser && currentUser.isAdmin) {
    return <Outlet />;
  }

  // Not an admin, redirect to home
  return <Navigate to="/devices" />;
};

export default AdminRoute;